import React from 'react';
import { Neo } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import ManageSecurityTransferComponentVM from './ManageSecurityTransferComponentVM';
import moment from 'moment';
import { ModalUtils, Validation } from '@singularsystems/neo-core';


interface IManageSecurityTransferComponentProps {
    viewModel: ManageSecurityTransferComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageSecurityTransferComponent extends React.Component<IManageSecurityTransferComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;

        return (
            <>
                {<Neo.Card title={`${viewModel.managedSecurityTransfer.securityTransferID === 0 ? TextConstants.Titles.AddSecurityTransfer : TextConstants.Titles.EditSecurityTransfer}`}>
                    <>
                        <Neo.Form
                            model={viewModel.managedSecurityTransfer}
                            onSubmit={() => this.props.onSave()}
                            validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                            onInvalid={this.onFormInvalid}>
                            <Neo.GridLayout lg={4}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.FromStockbroker}
                                    bind={viewModel.managedSecurityTransfer.meta.staticServiceProviderFileGroupingIDFrom}
                                    select={{ items: viewModel.fileGroupingList, displayMember: "serviceProviderGroupingName", valueMember: "staticServiceProviderFileGroupingId" }}
                                    onClick={() => {
                                        viewModel.StockBrokerDropDownOnClicked()
                                    }}/>
                                <>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.FromAccount}>
                                    <Neo.AutoCompleteDropDown
                                        bind={viewModel.managedSecurityTransfer.meta.accountFrom}
                                        bindDisplay={viewModel.managedSecurityTransfer.meta.accountFrom}
                                        displayMember={"serviceProviderAccountNumber"} 
                                        itemSource={(searchValue) => viewModel.clientAccountApiClient.getClientAccountNumbersListByCriteria(searchValue, viewModel.managedSecurityTransfer.meta.staticServiceProviderFileGroupingIDFrom.value as number)}
                                        onInputChange={() => {viewModel.accountDropDownClicked()}}
                                        items={viewModel.clientAccountApiClient.getClientAccountNumbersListByCriteria(" ", viewModel.managedSecurityTransfer.meta.staticServiceProviderFileGroupingIDFrom.value as number)
                                        .then((arr) => arr.data.slice(0,10).sortBy('serviceProviderAccountNumber'))}
                                     /> 
                                    </Neo.FormGroup>
                                </>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.ToStockbroker}
                                    bind={viewModel.managedSecurityTransfer.meta.staticServiceProviderFileGroupingIDTo}
                                    select={{ items: viewModel.fileGroupingList, displayMember: "serviceProviderGroupingName", valueMember: "staticServiceProviderFileGroupingId" }} />
                                <Neo.FormGroup 
                                    label={TextConstants.Labels.ToAccount}
                                    bind={viewModel.managedSecurityTransfer.meta.accountTo} 
                                />
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={4}>
                                <Neo.FormGroup 
                                    label={TextConstants.Labels.AccountNumber}
                                    display={viewModel.managedSecurityTransfer.meta.clientPolicyNumber}/>
                                <Neo.FormGroup 
                                    label={TextConstants.Labels.ClientName} 
                                    display={viewModel.managedSecurityTransfer.meta.clientName} />
                                <Neo.FormGroup 
                                    className="customMarginTop29"
                                    label={TextConstants.Labels.BookTransfer} 
                                    bind={viewModel.managedSecurityTransfer.meta.isExternalInd} 
                                    input={{type: "switch"}}/>
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={4}>
                                <Neo.FormGroup
                                    appendText="fa-calendar"
                                    label={TextConstants.Labels.TransferEntryDate}
                                    bind={viewModel.managedSecurityTransfer.meta.transferEntryDate}
                                    dateProps={{ minDate: moment().subtract(3, 'months').toDate() }} />
                                <Neo.FormGroup
                                    appendText="fa-calendar"
                                    label={TextConstants.Labels.ExecutionDate}
                                    bind={viewModel.managedSecurityTransfer.meta.executionDate}
                                    dateProps={{ minDate: moment().subtract(3, 'months').toDate() }} />
                                <Neo.FormGroup className="customMarginTop29"
                                    label={TextConstants.Labels.TaxableTransfer}
                                    bind={viewModel.managedSecurityTransfer.meta.isTaxableTransferInd}
                                    input={{type: "switch"}} />
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={2}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.Notes}
                                    bind={viewModel.managedSecurityTransfer.meta.notes}
                                    input={{ rows: 5 }} />
                            </Neo.GridLayout>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>

                    </>
                </Neo.Card>}
            </>
        );
    }
    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidSecurityTransferDetails);
        }
    }
}